import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate-pipe';

@Component({
  selector: 'app-auth-layout-reset-password',
  imports: [TranslatePipe],
  templateUrl: './auth-layout-reset-password.component.html',
  styleUrl: './auth-layout-reset-password.component.scss',
})
export class AuthLayoutResetPasswordComponent {}
